import { DynamicTabContent } from "@/components/layout-2/dynamic-tab-content";
import { useDynamicDetailContext } from "@/contexts/dynamic-detail";
import { LoaderCircle } from "lucide-react";
import { useParams } from "react-router-dom";

interface GenericDetailDynamicTabPageProps {
    objectType: string;
    idParam: string;
}

export function GenericDetailDynamicTabPage({ objectType, idParam }: GenericDetailDynamicTabPageProps) {
    const params = useParams();
    const objectId = params[idParam]!;
    const tabPath = params.tabPath!;

    const { tabs, loading } = useDynamicDetailContext();

    const currentTab = tabs.find(tab => tab.route_path === tabPath);

    if (loading) {
        return (
            <div className="flex items-center justify-center p-6">
                <LoaderCircle className="h-6 w-6 animate-spin" />
            </div>
        );
    }

    if (!currentTab) {
        return (
            <div className="flex items-center justify-center p-8">
                <div className="text-red-500">Tab not configured: {tabPath}</div>
            </div>
        );
    }

    return <DynamicTabContent objectType={objectType} objectId={objectId} tab={currentTab} subPath={params["*"]} />;
}
